export default "__VITE_ASSET__DgsCUkeR__"